export function saveToLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  
export function loadFromLocalStorage(key) {
    try {
      const value = localStorage.getItem(key);
      return JSON.parse(value);
    } catch {
      return null;
    }
  }
  
  export function removeFromLocalStorage(key) {
    localStorage.removeItem(key);
  }